import React, {useState, useRef} from "react";

export default function AppFormikInputWithAddLabel(props) {
    const {
        formik,
        stFormClass,
        inputType,
        labelName,
        isRequired,
        placeholder,
        formikFieldName,
        hasLimit,
        chractersLimit,
        noErrorMessage,
        disabled,

        addLabel,

        value,
        onChange = () => { },
        error,
        isDisabled
    } = props;

    // states
    const [inputFocus, setInputFocus] = useState(false)

    // refs
    const inputRef = useRef(null)

    // on focus
    const onInputFocus = ev => {
        setInputFocus(true)
    }

    // on blur
    const onInputBlur = ev => {
        setInputFocus(false)
    }

    return (
        <div className={`st-form-with-add-label ${stFormClass || ""} ${error || (formik.touched[formikFieldName] && formik.errors[formikFieldName]) ? "has-msg msg-error" : "" } ${hasLimit ? "input-container-with-text-length has-limit" : ""} ${isDisabled ? "disabled" : ""}`}>
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && (
                        <span className="required ms-1 st-fs-12">
                            (required)
                        </span>
                    )}
                </label>
            ) : null}

            {/* main field */}
            <div className={`content-main d-flex ${inputFocus ? "focus" : ""}`} onClick={() => inputRef?.current?.focus()}>
                {
                    // additional label
                    addLabel ? (
                        <div className="add-label">
                            {addLabel}
                        </div>
                    ) : null
                }

                {/* input */}
                <input
                    type={inputType ?? "text"}
                    className="media-body"
                    placeholder={placeholder}
                    id={formikFieldName}
                    disabled={disabled}
                    ref={inputRef}
                    {...formik.getFieldProps(formikFieldName)}
                    value={value || formik?.values[formikFieldName]}
                    onChange={(e) => {
                        formik.handleChange(e)
                        onChange(e)
                    }}
                    onFocus={ev => {
                        onInputFocus(ev) // custom focus function
                    }}
                    onBlur={ev => {
                        onInputBlur(ev) // custom focus function
                        formik.handleBlur(ev)
                    }}
                />
            </div>
            
            {
                /* form message */
                !noErrorMessage ? (error || (formik.touched[formikFieldName] && formik.errors[formikFieldName])) && (
                          <div className="st-form-msg">
                              <p className="st-fs-12">
                                  {error || formik.errors[formikFieldName]}
                              </p>
                          </div>
                      )
                    : null
            }
            {
                /* text length */
                hasLimit ? (
                    <div className="text-length">
                        <p className="">
                            {`${
                                formik.getFieldProps(formikFieldName)?.value
                                    ?.length
                            } of ${chractersLimit ?? 0} characters used`}
                        </p>
                    </div>
                ) : null
            }
        </div>
    );
}
